<template>
	<div class="productSort">
		<div>
			<form @submit.prevent="submitForm">
				<div class="header acea-row row-center-wrapper" ref="header">
					<div class="acea-row row-between-wrapper input" style="width:95%">
						<span class="iconfont icon-sousuo"></span>
						<input type="text" placeholder="搜索商品信息" v-model="search" style="width: 90%;" />
					</div>
				</div>
			</form>
			<div class="aside">
				<div class="item acea-row row-center-wrapper" :class="index === navActive ? 'on' : ''"
					v-for="(item, index) in category" :key="index" @click="
		        asideTap(index, item.id, item.cate_name, item.merchant_id, item.pid)
		      ">
					<span>{{ item.cate_name }}</span>
				</div>
			</div>
			<div class="conter" @scroll.native="onScroll" style="padding:0 2% 0 1%">
				<div class="listw" style="padding-right:3%">
					<div class="title acea-row row-center-wrapper" ref="title" style="display: none;"
						v-for="(item, index) in category"></div>
					<div></div>
					<div class="list acea-row">
						<router-link class="item acea-row row-column row-middle" v-for="(child, index) in productList2"
							:key="index" :to="{
		            path: '/detail',
		            query: {
		              id: child.id,
		              mid: child.merchant_id,
		              type: 1,
		              is_exchange: is_exchange
		            }
		          }">
							<div class="item2">
								<div class="left">
									<div class="picture" style="position: relative;">
										<div style="position: absolute;background: rgba(0, 0, 0,0.7);" >
											<img src="http://app.funengtuan.com/imgs/noshop.png" class="image" v-if="child.stock==0" />
										</div>
										<img :src="child.image"/>
									</div>
									<!-- <div class="name line1">{{ child.store_name }}</div> -->
								</div>
								<div class="right" style="display:block">
									<div class="name">
										<div v-if="child.is_recipel==1"
											style="display: inline-block;width:2.5em;vertical-align: middle;">
											<img src="http://app.funengtuan.com/imgs/rx.png" style="width:100%;vertical-align: text-top;" />
										</div>
										{{ child.store_name }}
									</div>
									<span>价格：￥{{ child.price }}
										<img src="../../../public/gouwu.png" alt="" /></span>
								</div>
							</div>
						</router-link>
					</div>
					<div style="text-align:center;height:0.5rem;line-height:0.5rem;font-size:0.3rem">
						{{ listnone }}
					</div>
				</div>
			</div>
			<div style="height:1.2rem;"></div>
		</div>

	</div>
</template>
<script>
	import debounce from "lodash.debounce";
	import {
		getCategory2
	} from "@api/store";
	import {
		getGoodList
	} from "@api/store";
	import {
		trim
	} from "../../utils";

	export default {
		name: "GoodsClass",
		components: {},
		props: {},
		data: function() {
			console.log(this.$route.query.index);
			return {
				category: [],
				navActive: this.$route.query.index,
				search: "",
				lock: false,
				productList2: "",
				data: {},
				id: "",
				id2: "",
				id5: "",
				id6: "",
				page: 1,
				listnone: "",
				index: this.$route.query.index
			};
		},
		watch: {
			"$route.params.pid": function(n) {
				console.log(n);
				if (n) {
					this.activeCateId(n);
				}
			}
		},
		// created(index, id, name) {
		//   this.asideTap(index, id, name);
		// },
		mounted: function() {
			document.addEventListener("scroll", this.onScroll, false);
			this.loadCategoryData();
			// console.log(this.index);
			// console.log(this.navActive);
		},
		methods: {
			activeCateId(n) {
				let index = this.$route.query.index;
				console.log(index);
				n = parseInt(n);
				if (!n) return;
				this.category.forEach((cate, i) => {
					if (cate.id === n) index = i;
				});

				if (index !== this.navActive) {
					this.asideTap(index, id, name, id2, id3);
				}
			},
			loadCategoryData() {
				getCategory2().then(res => {
					this.is_exchange = res.data.is_exchange;
					this.category = res.data.newcateogry;
					let id = res.data.newcateogry[0].id;
					let name = res.data.newcateogry[0].cate_name;
					let id2 = res.data.newcateogry[0].merchant_id;
					let id3 = res.data.newcateogry[0].pid;
					this.id5 = res.data.newcateogry[0].id;
					this.id6 = res.data.newcateogry[0].merchant_id;
					this.page = 1;
					let data = {
						page: this.page,
						limit: 20,
						// keyword: name,
						sid: id, //二级分类id
						news: 0,
						priceOrder: "",
						merchant_id: id2,
						salesOrder: ""
					};
					getGoodList(data).then(res => {
						this.productList2 = res.data;
					});
				});
			},
			submitForm: function() {
				var val = trim(this.search);
				// console.log(this.id6)
				// console.log(val);
				// return false;
				if (val) {
					this.$router.push({
						path: "/goods_list",
						query: {
							s: val,
							mid: this.id6
						}
					});
					setTimeout(() => (this.search = ""), 500);
				}
			},
			asideTap(index, id, name, id2, id3) {
				this.productList2 = [];
				const top =
					this.$refs.title[index].offsetTop -
					this.$refs.header.offsetHeight -
					window.scrollY;
				this.id = id;
				this.id2 = id2;
				this.lock = true;
				window.scrollBy({
					top,
					left: 0,
					behavior: "smooth"
				});
				this.navActive = index;
				var that = this;
				that.listnone = "";
				that.page = 1;
				let data = {
					page: that.page,
					limit: 20,
					// keyword: name,
					sid: id, //二级分类id
					news: 0,
					priceOrder: "",
					merchant_id: id2,
					salesOrder: ""
				};
				getGoodList(data).then(res => {
					that.productList2 = res.data;
				});
			},
			onScroll: debounce(function() {
				var that = this;
				that.listnone = "加载中...";
				if (this.lock) {
					this.lock = false;
					return;
				}
				const headerHeight = this.$refs.header.offsetHeight,
					// { scrollY } = window,
					titles = this.$refs.title;
				if (this.id == "") {
					this.id = this.id5;
					this.id2 = this.id6;
				}
				this.page++;
				let data = {
					page: this.page,
					limit: 20,
					// keyword: name,
					sid: this.id, //二级分类id
					news: 0,
					priceOrder: "",
					merchant_id: this.id2,
					salesOrder: ""
				};

				getGoodList(data).then(res => {
					if (this.category.length == 0) {
						that.listnone = "";
						return false;
					}
					if (res.data.length == 0) {
						that.listnone = "到底了";
					} else {
						that.listnone = "";
					}
					that.productList2 = that.productList2.concat(res.data);
					// console.log(that.productList2);
				});
				// titles.reduce((initial, title, index) => {
				// 	if (initial) return initial;
				// 	const parent = title.parentNode || title.parentElement;
				// console.log(headerHeight);
				// if (
				//   scrollY + headerHeight + 15 <
				//   title.offsetTop + parent.offsetHeight
				// ) {
				//   initial = true;
				//   this.navActive = index;
				// }
				// else if (innerHeight + scrollY + 15 > offsetHeight) {
				//   this.navActive = titles.length - 1;
				//   initial = true;
				// }
				// 	return initial;
				// }, false);
			}, 500)
		},
		beforeDestroy: function() {
			document.removeEventListener("scroll", this.onScroll, false);
		}
	};
</script>

<style scoped>
	.productSort .aside .item {
		height: 1rem !important;
		font-size: 0.29rem !important;
	}

	.productSort .conter .list .item {
		width: 100% !important;
		margin-top: 0.2rem !important;
		border-bottom: 1px solid rgba(40, 40, 40, 0.1);
		padding-bottom: 0.2rem !important;
	}

	.productSort .conter .list .item .name {
		font-size: 0.3rem !important;
		width: 2.4rem !important;
		text-align: left !important;
		height: auto !important;
	}

	.productSort .conter .list .item .picture {
		/* box-shadow: 0px 0px 4px 0px !important; */
		border-radius: 0% !important;
	}

	.productSort .conter .list .item .picture img {
		/* box-shadow: 0px 0px 4px 0px !important; */
		border-radius: 0% !important;
	}

	.productSort .conter .list .item .item2 .right span {
		color: #00c049 !important;
	}

	.productSort .conter .list .item .item2 {
		width: 100% !important;
		display: -webkit-flex;
		display: flex;
		align-items: center;
	}

	.productSort .conter .list .item .item2 .left {
		width: 1.2rem;
		margin-left: 10px;
	}

	.productSort .conter .list .item .item2 .right {
		flex: 1;
		margin-left: 10px;
		display: flex;
		height: 90%;
		flex-direction: column;
	}

	.productSort .conter .list .item .item2 .right span {
		display: block;
		flex: 1;
		line-height: 30px;
		font-size: 14px;
		color: #333333;
		width: 3.5rem;
	}

	.productSort .conter .list .item .item2 .right span img {
		width: 0.55rem;
		float: right;
		/* margin-top: -0.6rem; */
		border: 1px solid;
		border-radius: 100%;
		padding: 5px;
	}

	.chufang {
		padding: 2px 5px;
		background-color: #ff290e;
		/* background-color: #00c049; */
		color: #ffffff;
		font-size: 12px;
		display: inline-block;
		border-radius: 10px;
	}
</style>
